import { useAsyncEffect, useRouter } from "@relode/core";

import { CandidateState } from "../candidateState";
import { FeatureActions } from "../combinedCandidatesFeatureActions";

export const useCandidateHandlers = (
    state: CandidateState,
    actions: FeatureActions
) => {
    const {
        match: {
            params: { jobId, leadId },
        },
    } = useRouter();

    useAsyncEffect(async () => {
        //TODO what happens if leadId or jobId is missing?
        await actions.loadCandidate(jobId, leadId);
    }, [leadId, jobId]);
};
